import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../../Components/Items";
import numeroALetra from "../../Components/numeroALetra";
import { formatQRTotal } from "../../Components/RoundQRDecimals";
import { PDF_COLORS, pdfStylesV2, lineLayoutsV2, divisorV2, seccionHeadingV2, PDF_PAGE_MARGINS, applyPdfColors } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFClientInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFClientInfo";
import { PDFItemsTableV2 } from "../../Components/PdfComponents/componentsv2.0/PDFItemsTable";
import { PDFSummarySectionV2 } from "../../Components/PdfComponents/componentsv2.0/PDFTotalsSummary";
import { PDFPaymentInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPaymentInfo";
import { PDFNotesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFNotes";
import { PDFBrandFooterV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import { PDFCartaPorteV2 } from "../../Components/PdfComponents/componentsv2.0/PDFCartaPorte";
import { PDFCfdiFooterV2 } from "../../Components/PdfComponents/componentsv2.0/PDFCfdiFooter";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");


const notaDeCreditoVentaFPdfV2 = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const logoBiwo = values.logoBiwo?.base64Completa || values.respuestaFactura?.logoBiwo?.base64Completa;

  applyPdfColors(empresa);

  const dataSat = values.respuestaFactura.dataSat;
  const dataExtra = values.respuestaFactura.data;
  const decimalesTipoCambioPdf = Number.isFinite(Number(empresa?.decimalesTipoCambioPdf)) ? Number(empresa.decimalesTipoCambioPdf) : 4;
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };

  let cartaPorte;

  if (dataSat?.Complemento?.Any.find(item => item['cartaporte31:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte31:CartaPorte'])['cartaporte31:CartaPorte'];
  }
  if (dataSat?.Complemento?.Any.find(item => item['cartaporte30:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte30:CartaPorte'])['cartaporte30:CartaPorte'];
  }

  const conceptos = dataSat.Conceptos.map((valueConcepto) => {
    let iva = 0;
    let ieps = 0;
    valueConcepto.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
      }
      return null;
    });
    return [
      { style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right" },
      { text: valueConcepto.ClaveUnidad, style: "textoTablaChico", alignment: "center" },
      { text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" },
      { text: valueConcepto.NoIdentificacion, style: "textoTablaChico", alignment: "center" },
      {
        text: valueConcepto.Descripcion + (valueConcepto.Observaciones ? ("\n" + valueConcepto.Observaciones) : ""),
        style: "textoTablaChico",
        alignment: "left",
      },
      { text: dineroDisabledMask(iva), style: "textoTablaChico", alignment: "right" },
      ...(empresa.imprimirIEPS
        ? [{ text: dineroDisabledMask(ieps), style: "textoTablaChico", alignment: "right" }]
        : []),
      { text: dineroDisabledMask(valueConcepto.ValorUnitario, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "right" },
      { text: dineroDisabledMask(valueConcepto.Importe), style: "textoTablaChico", alignment: "right" },
    ];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]
    : [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])];

  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002"
      ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
      : a.Impuesto === "003"
        ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
        : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002"
      ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
      : b.Impuesto === "003"
        ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
        : b["@ImpLocTrasladado"];
    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map((valueImpuesto) => {
    let nombre = "";
    if (valueImpuesto.Impuesto === "002") {
      nombre = "IVA";
    } else if (valueImpuesto.Impuesto === "003") {
      nombre = "IEPS";
    } else {
      nombre = valueImpuesto["@ImpLocTrasladado"];
    }
    if (valueImpuesto.TipoFactor === "Tasa") {
      nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
    } else if (valueImpuesto.TipoFactor === "Cuota") {
      nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
    }
    return { label: nombre, value: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0) };
  });

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]
    : [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])];

  const retencionesTotales = nuevoArrayRetFL.map((valueRetencion) => {
    let nombre = "Retención ";
    if (valueRetencion.Impuesto === "001") {
      nombre = nombre + "ISR";
    } else if (valueRetencion.Impuesto === "002") {
      nombre = nombre + "IVA";
    } else {
      nombre = valueRetencion["@ImpLocRetenido"];
    }
    return { label: nombre, value: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]) };
  });

  const totalImpFL = dataSat.Impuestos.TotalImpuestosTrasladados + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeTraslados"] || 0) || 0;
  const totalRetFL = dataSat.Impuestos.TotalImpuestosRetenidos + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeRetenciones"] || 0) || 0;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } };
  }

  const filasBanco1 = [
    { label: "Banco:", value: empresa.banco ? empresa.banco : "" },
    ...(empresa.swiftCode ? [{ label: "Swift Code:", value: empresa.swiftCode ? empresa.swiftCode : "" }] : []),
    ...(empresa.abaCode ? [{ label: "ABA Code:", value: empresa.abaCode ? empresa.abaCode : "" }] : []),
    { label: "Cuenta:", value: empresa.cuentaBanco ? empresa.cuentaBanco : "" },
    { label: "Cuenta CLABE:", value: empresa.cuentaClabe ? empresa.cuentaClabe : "" },
  ];

  // --- Datos carta porte (mismas estructuras que el clásico) ---
  let ubicaciones = [];
  if (cartaPorte?.Ubicaciones) {
    for (const ubicacion of cartaPorte.Ubicaciones) {
      ubicaciones.push(
        [
          { style: 'textoTablaChico', text: ubicacion.TipoUbicacion + ' - ' + ubicacion.IDUbicacion, alignment: 'center' },
          { style: 'textoTablaChico', text: ubicacion.RFCRemitenteDestinatario, alignment: 'center' },
          { style: 'textoTablaChico', text: ubicacion.NombreRemitenteDestinatario, alignment: 'lefth' },
          { text: 'MXN', style: 'textoTablaChico', alignment: 'center' },
          { text: '-', style: 'textoTablaChico', alignment: 'center' },
          { text: ubicacion.FechaHoraSalidaLlegada, style: 'textoTablaChico', alignment: 'center' },
        ],
        [
          { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'lefth' },
          { style: 'textoTablaChico', text: (ubicacion.Domicilio.Calle ? ubicacion.Domicilio.Calle : '') + (ubicacion.Domicilio.NumeroExterior ? (' #' + ubicacion.Domicilio.NumeroExterior) : '') + (ubicacion.Domicilio.NumeroInterior ? (' - ' + ubicacion.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacion.Domicilio.ColoniaNombre + ' CP: ' + ubicacion.Domicilio.CodigoPostal + (ubicacion.Domicilio.Referencia ? (' Referencia: ' + ubicacion.Domicilio.Referencia) : '') + ' - ' + (ubicacion.Domicilio.MunicipioNombre ? ubicacion.Domicilio.MunicipioNombre : '') + ' ' + ubicacion.Domicilio.Estado + ' ' + ubicacion.Domicilio.Pais, alignment: 'lefth', colSpan: 5 },
          {}, {}, {}, {},
        ]
      );
    }
  }

  let figuras = [];
  if (cartaPorte?.FiguraTransporte) {
    for (const figura of cartaPorte.FiguraTransporte) {
      let tipoFiguraTexto;
      if (figura.TipoFigura === '01') tipoFiguraTexto = "Operador";
      else if (figura.TipoFigura === '02') tipoFiguraTexto = "Propietario";
      else if (figura.TipoFigura === '03') tipoFiguraTexto = "Arrendador";
      else if (figura.TipoFigura === '04') tipoFiguraTexto = "Notificado";

      const filaDomicilioFigura = figura?.Domicilio && Object.keys(figura.Domicilio).length > 0
        ? [[
          { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'left' },
          {
            style: 'textoTablaChico',
            text:
              (figura.Domicilio.Calle ? figura.Domicilio.Calle : '') +
              (figura.Domicilio.NumeroExterior ? ` #${figura.Domicilio.NumeroExterior}` : '') +
              (figura.Domicilio.NumeroInterior ? ` - ${figura.Domicilio.NumeroInterior}` : '') +
              (figura.Domicilio.ColoniaNombre ? ` Col: ${figura.Domicilio.ColoniaNombre}` : '') +
              (figura.Domicilio.CodigoPostal ? ` CP: ${figura.Domicilio.CodigoPostal}` : '') +
              (figura.Domicilio.Referencia ? ` Referencia: ${figura.Domicilio.Referencia}` : '') +
              (figura.Domicilio.MunicipioNombre ? ` - ${figura.Domicilio.MunicipioNombre}` : '') +
              (figura.Domicilio.Estado ? ` ${figura.Domicilio.Estado}` : '') +
              (figura.Domicilio.Pais ? ` ${figura.Domicilio.Pais}` : ''),
            alignment: 'left', colSpan: 5
          },
          {}, {}, {}, {}
        ]]
        : [];

      figuras.push(
        [
          { style: 'textoTablaChico', text: figura.TipoFigura + ' - ' + tipoFiguraTexto, alignment: 'center' },
          { style: 'textoTablaChico', text: figura.RFCFigura, alignment: 'center' },
          { style: 'textoTablaChico', text: figura.NombreFigura, alignment: 'lefth' },
          { text: figura.NumLicencia, style: 'textoTablaChico', alignment: 'center' },
          { text: figura.ResidenciaFiscalFigura ? figura.ResidenciaFiscalFigura : '-', style: 'textoTablaChico', alignment: 'center' },
          { text: figura.NumRegIdTribFigura ? figura.NumRegIdTribFigura : '-', style: 'textoTablaChico', alignment: 'center' },
        ],
        ...filaDomicilioFigura
      );
    }
  }

  let mercancias = [];
  if (cartaPorte?.Mercancias?.Mercancia) {
    for (const mercancia of cartaPorte.Mercancias.Mercancia) {
      let agregarFinalMercancias = [];
      let cantidadTotal = 0;
      if (mercancia.CantidadTransporta) {
        for (const cantidad of mercancia.CantidadTransporta) {
          cantidadTotal += cantidad.Cantidad;
          const ubicacionOrigen = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDOrigen);
          const ubicacionDestino = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDDestino);
          agregarFinalMercancias.push([
            { style: 'textoTablaChico', text: cantidad.Cantidad, alignment: 'right' },
            { style: 'textoTablaChico', text: 'Origen: ' + ubicacionOrigen.IDUbicacion + ' - ' + (ubicacionOrigen.Domicilio.Calle ? ubicacionOrigen.Domicilio.Calle : '') + (ubicacionOrigen.Domicilio.NumeroExterior ? (' #' + ubicacionOrigen.Domicilio.NumeroExterior) : '') + (ubicacionOrigen.Domicilio.NumeroInterior ? (' - ' + ubicacionOrigen.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionOrigen.Domicilio.ColoniaNombre + ' CP: ' + ubicacionOrigen.Domicilio.CodigoPostal + (ubicacionOrigen.Domicilio.Referencia ? (' Referencia: ' + ubicacionOrigen.Domicilio.Referencia) : '') + ' - ' + (ubicacionOrigen.Domicilio.MunicipioNombre ? ubicacionOrigen.Domicilio.MunicipioNombre : '') + ' ' + ubicacionOrigen.Domicilio.Estado + ' ' + ubicacionOrigen.Domicilio.Pais, alignment: 'lefth', colSpan: 3 },
            {},
            {},
            { style: 'textoTablaChico', text: 'Destino: ' + ubicacionDestino.IDUbicacion + ' - ' + (ubicacionDestino.Domicilio.Calle ? ubicacionDestino.Domicilio.Calle : '') + (ubicacionDestino.Domicilio.NumeroExterior ? (' #' + ubicacionDestino.Domicilio.NumeroExterior) : '') + (ubicacionDestino.Domicilio.NumeroInterior ? (' - ' + ubicacionDestino.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionDestino.Domicilio.ColoniaNombre + ' CP: ' + ubicacionDestino.Domicilio.CodigoPostal + (ubicacionDestino.Domicilio.Referencia ? (' Referencia: ' + ubicacionDestino.Domicilio.Referencia) : '') + ' - ' + (ubicacionDestino.Domicilio.MunicipioNombre ? ubicacionDestino.Domicilio.MunicipioNombre : '') + ' ' + ubicacionDestino.Domicilio.Estado + ' ' + ubicacionDestino.Domicilio.Pais, alignment: 'lefth', colSpan: 4 },
            {},
            {},
            {},
          ]);
        }
      }
      mercancias.push([
        { style: 'textoTablaChico', text: cantidadTotal, alignment: 'right' },
        { text: mercancia.Unidad, style: 'textoTablaChico', alignment: 'center' },
        { text: mercancia.BienesTransp + ' - ' + mercancia.Descripcion, style: 'textoTablaChico', alignment: 'center' },
        { text: mercancia.CveMaterialPeligroso ? mercancia.CveMaterialPeligroso : 'No', style: 'textoTablaChico', alignment: 'left' },
        { text: mercancia.Embalaje ? (mercancia.Embalaje + ' - ' + mercancia.DescripEmbalaje) : '-', style: 'textoTablaChico', alignment: 'right' },
        { text: mercancia.PesoEnKg, style: 'textoTablaChico', alignment: 'right' },
        { text: mercancia.FraccionArancelaria, style: 'textoTablaChico', alignment: 'right' },
        { text: mercancia.PermisoImportacion ? mercancia.PermisoImportacion : '-', style: 'textoTablaChico', alignment: 'right' }
      ]);
      if (mercancia.GuiasIdentificacion) {
        for (const guiaIdent of mercancia.GuiasIdentificacion) {
          mercancia.push([
            { text: 'No. de Guia', style: 'tituloTabla', colSpan: 2 },
            {},
            { text: guiaIdent.NumeroGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' },
            { text: 'Descripción Guía', style: 'tituloTabla' },
            { text: guiaIdent.DescripGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right', colSpan: 2 },
            {},
            { text: 'Peso Guía', style: 'tituloTabla' },
            { text: guiaIdent.PesoGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' }
          ]);
        }
      }
      for (const agregarFinalMercancia of agregarFinalMercancias) {
        mercancias.push(agregarFinalMercancia);
      }
    }
  }

  let remolquesData = [];
  if (cartaPorte?.Mercancias?.Autotransporte?.Remolques) {
    remolquesData = cartaPorte.Mercancias.Autotransporte.Remolques.map(valueR => [
      { text: valueR.SubTipoRem + ' - ' + valueR.DescripcionSubtipo, style: 'textoTablaChico', alignment: 'center' },
      { text: valueR.Placa, style: 'textoTablaChico', alignment: 'center' },
    ]);
  }

  // QR Carta Porte
  let qrCartaPorte = '';
  if (cartaPorte) {
    const formatearFechaSAT = (fechaISO) => {
      try {
        let fechaStr = '';
        if (fechaISO && typeof fechaISO === 'object' && typeof fechaISO.toISOString === 'function' && fechaISO._isAMomentObject) fechaStr = fechaISO.toISOString();
        else if (fechaISO instanceof Date) fechaStr = fechaISO.toISOString();
        else if (typeof fechaISO === 'string') fechaStr = fechaISO;
        else return '';
        return fechaStr.replace('Z', '').split('.')[0];
      } catch { return ''; }
    };
    if (Array.isArray(cartaPorte?.Ubicaciones) && dataSat?.Fecha && cartaPorte["IdCCP"]) {
      const origen = cartaPorte.Ubicaciones.find(ubi => ubi.TipoUbicacion === 'Origen');
      if (origen) {
        const fechaOrig = formatearFechaSAT(origen.FechaHoraSalidaLlegada);
        const fechaTimb = formatearFechaSAT(dataSat.Fecha);
        qrCartaPorte = `https://verificacfdi.facturaelectronica.sat.gob.mx/verificaccp/default.aspx?IdCCP=${cartaPorte["IdCCP"]}&FechaOrig=${fechaOrig}&FechaTimb=${fechaTimb}`;
      }
    }
  }

  const agregarCartaPorte = PDFCartaPorteV2({ cartaPorte, ubicaciones, figuras, mercancias, remolquesData, qrCartaPorte });

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;
  const totalqr = formatQRTotal(dataSat.Total);
  let cadena8 = dataExtra.selloCFDI;
  cadena8 = cadena8.slice(-8);
  const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${dataExtra.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`;

  // --- CFDI relacionados ---
  const getDescripcionTipoRelacion = (tipo) => {
    switch (tipo) {
      case "01": return "01 - Nota de crédito de los documentos relacionados";
      case "02": return "02 - Nota de débito de los documentos relacionados";
      case "03": return "03 - Devolución de mercancía sobre facturas o traslados previos";
      case "04": return "04 - Sustitución de los CFDI previos";
      case "05": return "05 - Traslados de mercancías facturados previamente";
      case "06": return "06 - Factura generada por los traslados previos";
      case "07": return "07 - CFDI por aplicación de anticipo";
      default: return tipo;
    }
  };
  const filasCfdiRelacionados = [];
  if (values.relacionesCFDI && Array.isArray(values.relacionesCFDI)) {
    values.relacionesCFDI.forEach(relacion => {
      filasCfdiRelacionados.push([
        { text: getDescripcionTipoRelacion(relacion.tipoRelacion), style: 'textoTablaChico', alignment: 'left' },
        { text: relacion.uuid, style: 'textoTablaChico', alignment: 'right' },
      ]);
    });
  }
  let tablaCfdiRelacionados = [];
  if (filasCfdiRelacionados.length > 0) {
    tablaCfdiRelacionados.push(
      seccionHeadingV2("CFDI Relacionados"),
      {
        style: "tableExample",
        table: {
          widths: ['40%', '60%'],
          body: [
            [{ text: "Tipo de Relación", style: "tituloTabla", fillColor: PDF_COLORS.tint }, { text: "Folio Fiscal (UUID)", style: "tituloTabla", fillColor: PDF_COLORS.tint }],
            ...filasCfdiRelacionados,
          ],
        },
        layout: lineLayoutsV2.rejilla,
      }
    );
  }

  // --- advansLeyenda ---
  let advansLeyenda = [];
  if (dataSat?.Receptor?.advansLeyenda) {
    advansLeyenda = [{
      style: "tableExample",
      table: {
        widths: ['*'],
        body: [[{ text: dataSat?.Receptor?.advansLeyenda, margin: [0, 4, 0, 4], style: "textoChico", border: [false, false, false, false] }]],
      },
      layout: lineLayoutsV2.cajaLimpia,
    }];
  }

  // --- Encabezado de información del documento (columna derecha) ---
  const headerMeta = [
    { label: "N° Nota de Crédito:", value: (dataSat.Serie ? dataSat.Serie : 'NDC') + ' - ' + dataSat.Folio },
    { label: "Moneda:", value: dataSat.Moneda },
    { label: "T.C.:", value: dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf) },
  ];

  // --- Cliente (identidad del receptor) ---
  const clienteLeft = [
    { label: "Nombre del cliente:", value: dataSat.Receptor.Nombre, strong: true },
    { label: "R.F.C:", value: dataSat.Receptor.Rfc },
    { label: "Uso de CFDI:", value: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion },
    { label: "Forma de pago:", value: "(" + dataSat.formaDePago.c_FormaPago + ") " + dataSat.formaDePago.descripcion },
    { label: "Método de pago:", value: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido" },
  ];

  const clienteRight = [
    { label: "Fecha:", value: moment(dataSat.Fecha).locale("es").format("LL") },
    { label: "Lugar de expedición:", value: dataSat.LugarExpedicion },
  ];

  // --- Cierre: importe con letra + datos bancarios (izquierda) ---
  const bancosRows = filasBanco1.filter((r) => r && String(r.value ?? "").trim() !== "");
  const importeLetra = {
    text: [
      { text: "Importe con letra:  ", style: "subheader" },
      { text: "( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )", style: "textoChico" },
    ],
    margin: [0, 0, 0, 8],
  };
  const cierreIzquierda = {
    stack: [
      importeLetra,
      PDFPaymentInfoV2({
        titulo: "Datos bancarios",
        rows: [
          { label: "Uso de CFDI:", value: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion },
          ...bancosRows,
        ],
      }),
    ],
  };

  // --- Totales ---
  const totalsRows = [
    { label: "Subtotal:", value: dineroDisabledMask(dataSat.SubTotal) },
    ...(dataSat.Descuento > 0 ? [{ label: "Descuento:", value: "- " + dineroDisabledMask(dataSat.Descuento) }] : []),
    ...impuestosTotales,
    { label: "TOTAL:", value: dineroDisabledMask(total), strong: true },
    ...retencionesTotales,
    ...(totalRetFL > 0 ? [{ label: "TOTAL PAGO:", value: dineroDisabledMask(dataSat.Total), strong: true }] : []),
  ];

  // --- Sección resumen (importe/bancos + totales). El QR fiscal va al pie. ---
  const seccionResumen = PDFSummarySectionV2({ left: cierreIzquierda, rows: totalsRows });

  const dd = {
    ...cancelado,
    content: [
      PDFHeaderV2({
        empresa,
        tituloPrincipal: "Nota de Crédito",
        tituloFolio: "N° " + (dataSat.Serie ? dataSat.Serie : "NDC") + " - " + dataSat.Folio,
        regimenFiscal: true,
        tipoComprobante: "egreso",
        meta: headerMeta,
      }),
      PDFClientInfoV2({ left: clienteLeft, right: clienteRight }),
      divisorV2(PDF_COLORS.neutralDivider, 7, 1),
      PDFItemsTableV2({
        title: [
          { text: "Cantidad", style: "tituloTabla" },
          { text: "Unidad", style: "tituloTabla" },
          { text: "Clave SAT", style: "tituloTabla" },
          { text: "Clave", style: "tituloTabla" },
          { text: "Descripción", style: "tituloTabla" },
          { text: "IVA", style: "tituloTabla" },
          ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
          { text: "P/U", style: "tituloTabla" },
          { text: "Importe", style: "tituloTabla" },
        ],
        conceptos,
        widths: [
          "8%",   // Cantidad
          "6%",   // Unidad
          "9%",   // Clave SAT
          "9%",   // Clave
          empresa.imprimirIEPS ? "29%" : "37%", // Descripción
          "8%",   // IVA
          ...(empresa.imprimirIEPS ? ["8%"] : []), // IEPS
          "10.5%", // P/U
          "12.5%", // Importe
        ],
      }),
      seccionResumen,
      PDFNotesV2(values.imprimirObservaciones && values.observaciones ? values.observaciones : null),
      ...advansLeyenda,
      ...agregarCartaPorte,
      ...tablaCfdiRelacionados,
      PDFCfdiFooterV2({ dataExtra, dataSat, qrLink: linkqr }),
    ],
    footer: PDFBrandFooterV2(logoBiwo),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };

  return dd;
};

export default notaDeCreditoVentaFPdfV2;
